// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { apiurl } from "../config/config";
// import Layout, { Container } from "../components/layout";
// import { Link, useParams } from "react-router-dom";

// export default function OnlineApplications() {
//   const { jobId } =  useParams();
//   // const jobId = "10000001";
//   const [applications, setApplications] = useState([]);
//   const [filteredApplications, setFilteredApplications] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [search, setSearch] = useState("");

//   useEffect(() => {
//     const fetchApplications = async () => {
//       try {
//         setLoading(true);
//         const response = await axios.get(
//           `${apiurl}/api/online-application/job/${jobId}`
//         );
//         setApplications(response.data);
//         setFilteredApplications(response.data);
//         setLoading(false);
//       } catch (err) {
//         setError("Failed to fetch applications.");
//         setLoading(false);
//       }
//     };

//     fetchApplications();
//   }, [jobId]);

//   const handleSearch = (e) => {
//     const value = e.target.value.toLowerCase();
//     setSearch(value);
//     const filtered = applications.filter(
//       (app) =>
//         app.candidateId?.toLowerCase().includes(value) ||
//         app.status?.toLowerCase().includes(value)
//     );
//     setFilteredApplications(filtered);
//   };

//   return (
//     <Layout>
//       <Container overflow={"overflow-scroll"}>
//         <div className="p-6 bg-white rounded-2xl shadow space-y-6">
//           <h2 className="text-2xl font-bold text-gray-800">
//             Applications for Job ID: {jobId}
//           </h2>

//           {/* Search Input */}
//           <div className="flex justify-end mb-4">
//             <input
//               type="text"
//               placeholder="Search by Candidate ID or Status"
//               value={search}
//               onChange={handleSearch}
//               className="w-full sm:w-1/3 px-4 py-2 border rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
//             />
//           </div>

//           {/* Table */}
//           <div className="overflow-x-auto">
//             <table className="min-w-full divide-y divide-gray-200 shadow-sm">
//               <thead className="bg-gray-50">
//                 <tr>
//                   <th className="px-6 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
//                     Application ID
//                   </th>
//                   <th className="px-6 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
//                     Name
//                   </th>
//                   <th className="px-6 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
//                     Email
//                   </th>
//                   <th className="px-6 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
//                     Phone
//                   </th>
//                   <th className="px-6 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
//                     Submitted At
//                   </th>
//                   <th className="px-6 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
//                     Status
//                   </th>
//                   <th className="px-6 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
//                     Answers
//                   </th>
//                   <th className="px-6 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
//                     Actions
//                   </th>
//                 </tr>
//               </thead>
//               <tbody className="bg-white divide-y divide-gray-200">
//                 {loading ? (
//                   <tr>
//                     <td colSpan={5} className="text-center py-4 text-gray-500">
//                       Loading applications...
//                     </td>
//                   </tr>
//                 ) : error ? (
//                   <tr>
//                     <td colSpan={5} className="text-center py-4 text-red-500">
//                       {error}
//                     </td>
//                   </tr>
//                 ) : filteredApplications.length === 0 ? (
//                   <tr>
//                     <td colSpan={5} className="text-center py-4 text-gray-500">
//                       No applications found.
//                     </td>
//                   </tr>
//                 ) : (
//                   filteredApplications.map((app) => (
//                     <tr key={app._id} className="hover:bg-gray-50 transition">
//                       <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 font-medium">
//                         {app.id}
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 font-medium">
//                         {app.name}
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 font-medium">
//                         {app.email}
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 font-medium">
//                         {app.phone}
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                         {new Date(app.submittedAt).toLocaleString()}
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 capitalize">
//                         {app.status}
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                         {app.answers.length}
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm text-blue-500">
//                         <Link
//                           to={`/online-applications/${jobId}/${app._id}`}
//                           className="hover:underline"
//                         >
//                           View
//                         </Link>
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </Container>
//     </Layout>
//   );
// }


import React, { useEffect, useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx"; // <-- make sure you install this: npm install xlsx
import { apiurl } from "../config/config";
import Layout, { Container } from "../components/layout";
import { Link, useParams } from "react-router-dom";

export default function OnlineApplications() {
  const { jobId } = useParams();
  const [applications, setApplications] = useState([]);
  const [filteredApplications, setFilteredApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetchApplications = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${apiurl}/api/online-application/job/${jobId}`
        );
        setApplications(response.data);
        setFilteredApplications(response.data);
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch applications.");
        setLoading(false);
      }
    };

    fetchApplications();
  }, [jobId]);

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearch(value);
    const filtered = applications.filter(
      (app) =>
        app.candidateId?.toLowerCase().includes(value) ||
        app.status?.toLowerCase().includes(value)
    );
    setFilteredApplications(filtered);
  };

  // ✅ Export to Excel
  // const exportToExcel = () => {
  //   if (applications.length === 0) {
  //     alert("No applications found to export.");
  //     return;
  //   }

  //   const rows = [];

  //   applications.forEach((app, index) => {
  //     // --- Personal details first ---
  //     rows.push({
  //       SNO: index + 1,
  //       "APPLICATION ID": app.id,
  //       NAME: app.name,
  //       EMAIL: app.email,
  //       PHONE: app.phone,
  //       "RESUME LINK": app.resume || "",
  //       STATUS: app.status,
  //       "SUBMITTED AT": new Date(app.submittedAt).toLocaleString(),
  //     });

  //     // --- Leave an empty row ---
  //     rows.push({});

  //     // --- Add questions & answers ---
  //     app.answers?.forEach((ans, idx) => {
  //       rows.push({
  //         QUESTION_NO: idx + 1,
  //         QUESTION: ans.questionText,
  //         ANSWER: ans.answer,
  //       });
  //     });

  //     // --- Add a separator row ---
  //     rows.push({});
  //     rows.push({ Separator: "-----------------------------" });
  //     rows.push({});
  //   });

  //   const worksheet = XLSX.utils.json_to_sheet(rows);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Applications");

  //   const fileName = `APPLICATIONS_${new Date()
  //     .toISOString()
  //     .split("T")[0]}.xlsx`;
  //   XLSX.writeFile(workbook, fileName);
  // };

  const exportToExcel = () => {
  if (applications.length === 0) {
    alert("No applications found to export.");
    return;
  }

  // Collect all unique questions from all applications
  const allQuestions = new Set();
  applications.forEach((app) => {
    app.answers?.forEach((ans) => {
      allQuestions.add(ans.questionText);
    });
  });

  const questionList = Array.from(allQuestions);

  // Prepare header row
  const headers = [
    "SNO",
    "APPLICATION ID",
    "NAME",
    "EMAIL",
    "PHONE",
    "RESUME LINK",
    "STATUS",
    "SUBMITTED AT",
    ...questionList,
  ];

  // Map applications into row objects
  const rows = applications.map((app, index) => {
    const row = {
      SNO: index + 1,
      "APPLICATION ID": app.id,
      NAME: app.name,
      EMAIL: app.email,
      PHONE: app.phone,
      "RESUME LINK": app.resume || "",
      STATUS: app.status,
      "SUBMITTED AT": new Date(app.submittedAt).toLocaleString(),
    };

    // Fill answers under the correct question header
    app.answers?.forEach((ans) => {
      row[ans.questionText] = ans.answer;
    });

    return row;
  });

  // Create worksheet
  const worksheet = XLSX.utils.json_to_sheet(rows, { header: headers });

  // Create workbook
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Applications");

  // Save file
  const fileName = `APPLICATIONS_${new Date()
    .toISOString()
    .split("T")[0]}.xlsx`;
  XLSX.writeFile(workbook, fileName);
};


  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        <div className="p-6 bg-white rounded-2xl shadow space-y-6">
          <div className="flex justify-between items-center">
            <h2 className="text-2xl font-bold text-gray-800">
              Applications for Job ID: {jobId}
            </h2>
            {/* ✅ Download Button */}
            <button
              onClick={exportToExcel}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition"
            >
              Download All Applications
            </button>
          </div>

          {/* Search Input */}
          <div className="flex justify-end mb-4">
            <input
              type="text"
              placeholder="Search by Candidate ID or Status"
              value={search}
              onChange={handleSearch}
              className="w-full sm:w-1/3 px-4 py-2 border rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
            />
          </div>

          {/* Table */}
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200 shadow-sm">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                    Application ID
                  </th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                    Name
                  </th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                    Email
                  </th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                    Phone
                  </th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                    Submitted At
                  </th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                    Status
                  </th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                    Answers
                  </th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {loading ? (
                  <tr>
                    <td colSpan={8} className="text-center py-4 text-gray-500">
                      Loading applications...
                    </td>
                  </tr>
                ) : error ? (
                  <tr>
                    <td colSpan={8} className="text-center py-4 text-red-500">
                      {error}
                    </td>
                  </tr>
                ) : filteredApplications.length === 0 ? (
                  <tr>
                    <td colSpan={8} className="text-center py-4 text-gray-500">
                      No applications found.
                    </td>
                  </tr>
                ) : (
                  filteredApplications.map((app) => (
                    <tr key={app._id} className="hover:bg-gray-50 transition">
                      <td className="px-6 py-4 text-sm text-gray-700 font-medium">
                        {app.id}
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-700 font-medium">
                        {app.name}
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-700 font-medium">
                        {app.email}
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-700 font-medium">
                        {app.phone}
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-500">
                        {new Date(app.submittedAt).toLocaleString()}
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-500 capitalize">
                        {app.status}
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-500">
                        {app.answers.length}
                      </td>
                      <td className="px-6 py-4 text-sm text-blue-500">
                        <Link
                          to={`/online-applications/${jobId}/${app._id}`}
                          className="hover:underline"
                        >
                          View
                        </Link>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </Container>
    </Layout>
  );
}